export default {
  blockTitle: "BLOCK_TITLE",
  blockAllBlock: "BLOCK_ALL_BLOCK",
  blockAllBlockTitle: "BLOCK_ALL_BLOCK_TITLE",
  blockName: "BLOCK_NAME",
  blockFirstSectionTitleForm: "BLOCK_FIRST_SECTION_TITLE_FORM",
  blockSecondSectionTitleForm: "BLOCK_SECOND_SECTION_TITLE_FORM",
  blockThirdSectionTitleForm: "BLOCK_THIRD_SECTION_TITLE_FORM",
  blockNameForm : "BLOCK_NAME_FORM",
  blockAddressForm: "BLOCK_ADDRESS_FORM",
  blockAddressOneForm: "BLOCK_ADDRESS_ONE_FORM",
  blockAddressTwoForm: "BLOCK_ADDRESS_TWO_FORM",
  blockPostalCodeForm: "BLOCK_POSTAL_CODE_FORM",
  blockCityForm: "BLOCK_CITY_FORM",
  blockCountryForm: "BLOCK_COUNTRY_FORM",
  blockAddPhotoForm: "BLOCK_ADD_PHOTO_FORM",
  blockNbrLotsForm: "BLOCK_NBRE_LOTS_FORM",
  blockDigicodeForm: "BLOCK_DIGICODE_FORM",
  blockManagersForm: "BLOCK_MANAGERS_FORM",
  blockGuardianForm: "BLOCK_GUARDIAN_FORM",
  blockCommercialForm: "BLOCK_COMMERCIAL_FORM",
  blockCreate: 'BLOCK_CREATE',
  blockUpdate: 'BLOCK_UPDATE',
  blockSave: 'BLOCK_SAVE',
  block: "BLOCK_PARC",
  blockLot: "BLOCK_LOT",
  blockTenant: "BLOCK_TENANT",
  blockInprocessTickets: "BLOCK_IN_PROCESS_TICKETS",
  blockDocuments: "BLOCK_DOCUMENTS",
  blockDocumentTitle: "BLOCK_DOCUMENT_TITLE",
  blockTicketInProcess: "BLOCK_TICKET_INPROCESS",
  blockSort: {
    name: 'SORT_NAME',
    city: 'LBL_CITY',
    totalApartment: 'LBL_TOTALAPARTMENT',
  },
  blockSidebar: {
    infos: "BLOCK_SIDEBAR_INFOS",
    ticket: "BLOCK_SIDEBAR_TICKET",
    contact: "BLOCK_SIDEBAR_CONTACT",
    apartment: "BLOCK_SIDEBAR_APARTMENT",
    equipment: "BLOCK_SIDEBAR_EQUIPMENT",
    vehicleFleet:"BLOCK_SIDEBAR_VEHICLE_FLEET",
    maintenance: "BLOCK_SIDEBAR_MAINTENANCE",
    document: "BLOCK_SIDEBABR_DOCUMENT"
  },
  blockFloor: 'BLOCK_FLOOR',
  blockNumberOfTenant: 'BLOCK_NUMBER_OF_TENANT',
  blockNumberOfInprocessEvent: 'BLOCKNUMBER_OF_INPROCESS_EVENT',
  blockLocationNumber: 'BLOCK_LOCATION_NUMBER',
  blockNumberOfDocument: 'BLOCK_NUMBER_OF_DOCUMENT',
  blockRef: "BLOCK_REF",
  blockNumApartments: "BLOCK_NUM_APARTMENTS",
  blockCaretaker: 'BLOCK_CARETAKER',
  blockOwnerTitle: 'BLOCK_OWNER_TITLE',
  blockOwnerAddress: 'BLOCK_OWNER_ADDRESS',
  blockTenantTitle: 'BLOCK_TENANT_TITLE',
  blockAddress: 'BLOCK_ADDRESS',
  blockPracticalInformation: 'BLOCK_PRACTICAL_INFORMATION',
  blockDetailPracticalInformation: 'BLOCK_DETAIL_PRACTICAL_INFORMATION',
  detailTableFields: {
    name: 'BLOCK_TABLE_NAME',
    address: 'BLOCK_TABLE_ADDRESS',
    email: 'BLOCK_TABLE_EMAIL',
    phoneNumber: 'BLOCK_TABLE_PHONE_NUMBER',
    cellPhoneNumber: 'BLOCK_TABLE_CELL_PHONE_NUMBER',
  },
  blockStatistic: 'BLOCK_STATISTIC',
  blockResolvedTicketStatistic: 'BLOCK_RESOLVED_TICKET_STATISTIC',
  blockReportedTicketStatistic: 'BLOCK_REPORTED_TICKET_STATISTIC',
  blockTotalHoursStatistic: 'BLOCK_TOTAL_HOURS_STATISTIC',
  blockTimeStatistic: 'BLOCK_TIME_STATISTIC',
  blockDocuemntAddDocument: 'BLOCK_DOCUMENT_ADD_DOCUMENT',
  blockHeaderApartment:'BLOCK_HEADER_APARTMENT',
  blockHeaderTenant:'BLOCK_HEADER_TENANT',
  blockDeleteMessage: 'BLOCK_DELETE_MESSAGE',
  blockEdit: "BLOCK_EDIT",
  blockDelete: "BLOCK_DELETE",
  blockOverallInformations: "BLOCK_OVERALL_INFORMATIONS",
  blockRecentDocuments: "BLOCK_RECENT_DOCUMENTS",
  blockPendingDocuments: "BLOCK_PENDING_DOCUMENTS",
  blockFavContacts: "BLOCK_FAV_CONTACTS",
  blockApartmentZones: "BLOCK_APARTMENT_ZONES",
  blockEnergeticInformations: "BLOCK_ENERGETIC_INFORMATIONS",
  blockDocumentText: "BLOCK_DOCUMENT_TEXT",
  blockPropertyInfos: "BLOCK_PROPERTY_INFOS",
  blockEquipments: "BLOCK_EQUIPMENTS",
  blockEquipment: {
    attributes: "BLOCK_EQP_ATTRIBUTES",
    updateAttribute: "BLOCK_UPDATE_ATTRIBUTE"
  }
}



// WEBPACK FOOTER //
// ./src/locales/block/index.ts